// extracted by mini-css-extract-plugin
export default {"root":"components_root__6PvdS","title":"components_title__sGRWH","button":"components_button__vte+b"};